'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthUsage(tfa, sites, credentials) {
  this.e4 = null;
  this.xM = null;
  this.EM = null;
  this.e4 = tfa;
  this.xM = sites;
  this.EM = credentials;
}
export { $c_Lpresto_types$TwoFactorAuthUsage as $c_Lpresto_types$TwoFactorAuthUsage };
$p = $c_Lpresto_types$TwoFactorAuthUsage.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthUsage;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthUsage() {
}
export { $h_Lpresto_types$TwoFactorAuthUsage as $h_Lpresto_types$TwoFactorAuthUsage };
$h_Lpresto_types$TwoFactorAuthUsage.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$TwoFactorAuthUsage)) {
    var x = this.e4;
    var x$2 = x$0.e4;
    if (((x === null) ? (x$2 === null) : x.i(x$2))) {
      var x$3 = this.xM;
      var x$4 = x$0.xM;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.EM;
      var x$6 = x$0.EM;
      return ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "TwoFactorAuthUsage";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.e4;
      break;
    }
    case 1: {
      return this.xM;
      break;
    }
    case 2: {
      return this.EM;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.k4 = (function() {
  return this.e4.jk;
});
function $isArrayOf_Lpresto_types$TwoFactorAuthUsage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ks)));
}
export { $isArrayOf_Lpresto_types$TwoFactorAuthUsage as $isArrayOf_Lpresto_types$TwoFactorAuthUsage };
var $d_Lpresto_types$TwoFactorAuthUsage = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthUsage, "presto.types$TwoFactorAuthUsage", ({
  ks: 1,
  aH: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$TwoFactorAuthUsage as $d_Lpresto_types$TwoFactorAuthUsage };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Usage.js.map
